"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _TableSearch = _interopRequireDefault(require("./TableSearch.style"));
var _Input = _interopRequireDefault(require("../input/Input"));
var _excluded = ["inputProps", "resultsText", "disabled", "clearable"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
var TableSearch = function TableSearch(_ref) {
  var inputProps = _ref.inputProps,
    resultsText = _ref.resultsText,
    disabled = _ref.disabled,
    clearable = _ref.clearable,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_TableSearch["default"], _extends({
    className: "search-wrapper ".concat(otherProps.className ? otherProps.className : '')
  }, otherProps), /*#__PURE__*/_react["default"].createElement(_Input["default"], _extends({}, inputProps, {
    onChange: function onChange(event, type) {
      !disabled && inputProps.onChange(event.target.value, type);
    },
    onKeyUp: function onKeyUp(event) {
      if (event.keyCode === 13) {
        !disabled && inputProps.onSearchSubmit();
      }
    },
    value: inputProps.value,
    icon: "ion-android-search",
    iconClick: function iconClick(type) {
      !disabled && inputProps.onSearchSubmit(type);
    },
    clearable: clearable,
    disabled: disabled
  })), /*#__PURE__*/_react["default"].createElement("p", {
    className: "results-text"
  }, resultsText));
};
TableSearch.defaultProps = {
  resultsText: '',
  disabled: false,
  clearable: true
};
TableSearch.propTypes = {
  disabled: _propTypes["default"].bool,
  clearable: _propTypes["default"].bool,
  /** Table search input props */
  inputProps: _propTypes["default"].shape({
    onChange: _propTypes["default"].func.isRequired,
    onSearchSubmit: _propTypes["default"].func.isRequired,
    value: _propTypes["default"].string.isRequired
  }).isRequired,
  /** The text for results found */
  resultsText: _propTypes["default"].string
};
var _default = exports["default"] = TableSearch;